import React from "react";
import FadingList from "../../FadingList/FadingList";
import UserManagement from "./UserManagement";

export default function UserPermissionList({token, users, accountId, givePermissions}) {
    const users_jsx = users && users.length > 0 ? users.map( user => {
        const user_permissions_jsx = (
                <div style={{textAlign: "center"}}>
                    <div>
                        <UserManagement
                            account_id={accountId}
                            user={user}
                            token={token}
                            givePermissions={givePermissions}
                        />
                    </div>
                </div>
            );

        return (
            <div>
                {user_permissions_jsx}
            </div>
        );
    }) : null;

    const users_to_list = users_jsx ? users_jsx.map( (user, index) => {
        return (<li key={index + "user_groups_list"} className="user-permissions-list">{user}</li>);}) : null

    return users_to_list.length === 1 ? users_to_list : <FadingList initialHeight={300}>{users_to_list}</FadingList>;

}